import { render, staticRenderFns } from "./getUser.vue?vue&type=template&id=68fa263b&"
import script from "./getUser.vue?vue&type=script&lang=js&"
export * from "./getUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports